import axios from './interceptor'
import { baseUrl } from './config'
import _ from 'lodash'
import moment from 'moment'
import { DEFAULT_RETRY_TIMES } from '../../constants/app'

export default {

  // > get all commodities of this merchant by merchantId (state.merchant.id)
  async getCommodities (merchantId) {
    const res = await axios.get(`${baseUrl}/c/menu?merchantID=${merchantId}`, {
      retry: DEFAULT_RETRY_TIMES,
    })
    return res.data
  },

  // waiter get setmenu
  async getSetmenus (merchantId) {
    const res = await axios.get(`${baseUrl}/c/setmenu`, {
      params: {
        merchantID: merchantId,
      },
      retry: DEFAULT_RETRY_TIMES,
    })
    return res.data
  },

  getListKey (categoryId, tag) {
    let key
    if (categoryId) {
      key = 'cat-' + categoryId
    } else if (tag) {
      key = 'tag-' + tag
    } else {
      key = 'promote'
    }
    return key
  },

  async listSet (merchantId, categoryId, isTakeaway, datetime) {
    const res = await axios.get(`${baseUrl}/c/setmenu`, {
      params: {
        merchantID: merchantId,
        categoryID: categoryId,
        takeaway: isTakeaway,
        ...datetime && { time: moment(datetime).format() },
      },
      retry: DEFAULT_RETRY_TIMES,
    })
    const sortedRes = _.sortBy(res.data, function (o) { return o.sold })
    return sortedRes
  },

  async listPromotedSet (merchantId, takeaway, datetime) {
    const res = await axios.get(`${baseUrl}/c/setmenu`, {
      params: {
        merchantID: merchantId,
        categoryID: null,
        promoted: true,
        takeaway: takeaway,
        tags: null,
        ...datetime && { time: moment(datetime).format() },
      },
      retry: DEFAULT_RETRY_TIMES,
    })
    return res.data
  },

  async list (merchantId, categoryId, tag, takeaway, datetime) {
    const res = await axios.get(`${baseUrl}/c/menu`, {
      params: {
        merchantID: merchantId,
        categoryID: categoryId,
        promoted: (!categoryId && !tag),
        takeaway: takeaway,
        tags: tag,
        ...datetime && { time: moment(datetime).format() },
      },
      retry: DEFAULT_RETRY_TIMES,
    })
    const sortedRes = _.sortBy(res.data, function (o) { return o.sold })
    return sortedRes
  },

  async listTags (merchantId, locale) {
    const res = await axios.get(`${baseUrl}/c/menu/tags`, {
      params: {
        merchantID: merchantId,
        locale: locale,
      },
      retry: DEFAULT_RETRY_TIMES,
    })
    return res.data
  },
}



// WEBPACK FOOTER //
// ./src/services/api/menu.js